import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/zh-CN';
import App from './App.vue';
import router from './router';
import store from './store';
import './styles/global.scss';

Vue.use(ElementUI, { locale, size: 'small' });
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
